import { z } from 'zod'
import type { VacancyShowFilterV4 } from '@/shared/api/generated/models/VacancyShowFilterV4'

export const internVacancyShows = ['all', 'notApplied', 'applied'] as const

export const internVacancySearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  show: z.enum(internVacancyShows).catch('all'),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['priority', 'title', 'orgname']).catch('priority'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})

export type InternVacancySearch = z.infer<typeof internVacancySearchSchema>

export const defaultInternVacancySearch: InternVacancySearch = {
  show: 'all',
  page: 1,
  pageSize: 10,
  sortBy: 'priority',
  direction: 'desc',
}

export const vacancyShowFilterValues = {
  notApplied: 0,
  applied: 1,
} as const satisfies Record<Exclude<InternVacancySearch['show'], 'all'>, VacancyShowFilterV4>
